<template>
  <div id="loginbg" class="loginbg">
    <transition name="el-fade">
      <div class="left" v-show="show">
        <div class="left_box">
          <div class="left_top">
            <div class="left_txt1">
              <p> SaaS</p>
              <p>后台管理系统</p>
            </div>
            <div class="left_txt2"></div>
            <div class="left_txt3">
              <p><span>◆</span> 人性化交互体验设计</p>
              <p><span>◆</span> AI智能系统，全新的使用体验</p>
              <p><span>◆</span> 新一代技术架构</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in">
      <div class="right" v-show="show">
        <div class="right_box">
          <div class="right_content1">登 录</div>
          <div class="right_content2">
            <!-- 登录表单区 -->
            <el-form :model="loginForm" ref="loginForm" :rules="loginFormRules" label-width="0px" class="login_form">
              <!-- 账户区 -->
              <el-form-item prop="phone">
                <el-input v-model="loginForm.phone" prefix-icon="el-icon-phone" placeholder="请输入手机号"
                  @keyup.enter.native="sureFormSubmit"></el-input>
              </el-form-item>
              <div style="height: 22px; width: 100%"></div>
              <!-- 密码区 -->
              <el-form-item prop="password">
                <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" placeholder="请输入用户密码"
                  @keyup.enter.native="sureFormSubmit"></el-input>
                <div style="height: 22px; width: 100%"></div>
              </el-form-item>

              <el-form-item prop="vcode" class="vcodeBox">
                <el-input v-model="loginForm.vcode" placeholder="请输入验证码" class="vcodeBoxInput"
                  @keyup.enter.native="sureFormSubmit"></el-input>
                <img :src="checkImg" @click="pullCheckCode" />

              </el-form-item>
              <!-- 按钮区 -->
              <el-form-item class="right_content3">
                <el-button type="primary" @click="sureFormSubmit" :loading="ConfirmLoading">登 录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </transition>
    <div class="right_back"></div>

    <!-- <div class="right_bottom">
      <p>©2022  SAAS 技术支持</p>
    </div> -->
  </div>
</template>

<style scoped src="../../../static/manage/css/style.css"></style>

<script>
var checkBTNLength = 84;
export default {
  data() {

    var isValidPhone = (rule, phone, callback) => {
      const regex = /^1[3-9]\d{9}$/;
      if (phone === "") {
        callback(new Error("请输入手机号"));
      } else if (!regex.test(phone)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    }


    return {
      checkCode:"",
      checkImg: "",
      //nametxt: "立即登录",
      ConfirmLoading: false,
      // 这是登录表单的数据绑定对象
      loginForm: {
        phone: "",
        password: "",
        vcode: "",
      },
      loginFormRules: {
        // 用户名验证
        phone: [{
          required: true,
          validator: isValidPhone,
          trigger: "blur"
        },],
        // 密码验证
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
        ],
      },
      show: false,
    };
  },
  mounted: function () {
    this.fadeIn(); //页面加载需要触发的函数
    this.pullCheckCode();
  },
  methods: {
    pullCheckCode() {
      let that = this;
      this.$httpPost({
        url: "/wlw_manage/checkVCode.aspx"
      }).then((res) => {
        that.checkImg = res.data.img;
        that.checkCode = res.code;
      });
    },
    toMallInfo: function () {
      this.$router.push({
        path: "menulist4",
        // name: 'mallList',
        query: {
          //参数
          loginCode: new Date().getTime(),
        },
      });
    },
    setItemWithExpiration(key, value, ttl) {
        const now = new Date();
        // ttl 是过期时间（单位：毫秒）
        const item = {
            value: value,
            expiration: now.getTime() + ttl,
        };
        localStorage.setItem(key, JSON.stringify(item));
    },
    //提交表单
    sureFormSubmit() {
      let that = this;
      //console.log(this.loginForm.username + "===" + this.loginForm.password);
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {

          if(that.checkCode != that.loginForm.vcode){
            that.$message.error("验证码错误，请重新输入！");
            return;
          }

          //(that.nametxt = "登录中..."),
          that.ConfirmLoading = true;
          // 验证通过之后的操作
          that
            .$httpPost({
              url: "/wlw_manage/serUser.aspx",
              data: {
                phone: that.loginForm.phone,
                password: that.loginForm.password,
              },
            })
            .then((res) => {
              if (res.nstatus === "1") {
                that.setItemWithExpiration("_admintoken_",res.token,60*1000*60*12);

                localStorage.setItem("time", res.time);
                localStorage.setItem("rent_id", res.rent_id);
                localStorage.setItem("userType", res.type);
                localStorage.setItem("username", res.username);
                localStorage.setItem("userIdentity", res.userIdentity);

                for(var i=1;i<checkBTNLength;i++){
                    localStorage.setItem("checked"+i, res["checked"+i]);
                }

                that.$message.success("登录成功！");
                setTimeout(function () {
                  that.toMallInfo();
                }, 1000);
              } else if(res.nstatus === "2"){
                that.$message.error("账号已经停用，请联系管理员！");
                this.ConfirmLoading = false;
              } else {
                //(that.nametxt = "立即登录"),
                that.$message.error("用户名或密码错误！");
                this.ConfirmLoading = false;
              }
            });

          /*this.axios({
            method: "post",
            url: "http://localhost:8080/api/wlw_manage/serUser.aspx",
            data: {
              name: this.loginForm.username,
              password: this.loginForm.password,
            },
          }).then(function (res) {
            console.log(res);
            if ((res.status = 200)) {
              //this.$message.success("登录成功！");
              //localStorage.setItem('token',"Bearer "+res.data.res.token)
              localStorage.setItem("token", "Bearer aaaaaaaaaaaaaa");
              that.$message.success("登录成功！");
              that.toMallInfo();
            }
          });*/
        } else {
          // 验证不通过之后的操作
          // ...
          this.ConfirmLoading = false;
          return false;
        }
      });
    },
    fadeIn() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang='less' scoped>
.el-form-item{
  margin-bottom: 0;
}
.vcodeBox {

  .el-form-item__content {
    .el-input {
      width: calc(100% - 130px);
      float: left;
    }


    img {
      width: 128px;
      float: left;
      cursor: pointer;
      height: 40px;
      border: 1px solid #DCDFE6;
      border-left: 0.6px solid #DCDFE6;
      box-sizing: border-box;
    }
  }
}

@media screen and (max-width:699px) {
  .left {
    display: block;
    height: 20%;
    width: 100%;
    padding-top: 30px;
    left: 0px;
  }

  .left_box {
    text-align: center;
  }

  .right {
    right: calc((100% - 400px)/2) !important;
    margin: 0 auto;
  }

  .right_bottom {
    width: 100%;
  }

  .right_back {
    display: none;
  }

  .left_txt3 {
    padding-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/manage_views/Home.vue